import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faH1,
  faH2,
  faH3,
  faH4,
  faListOl, faListUl, faHorizontalRule,
  faPlusCircle, faMinusCircle,
  faFilePlus, faPrint,
  faBars, faTrashAlt, faTimes
} from '@fortawesome/pro-regular-svg-icons'
// import { faBold as fasBold, faUnderline as fasUnderline } from '@fortawesome/pro-solid-svg-icons'
// import { faBold, faUnderline } from '@fortawesome/pro-regular-svg-icons';
// import { faCoffee as falCoffee } from '@fortawesome/pro-light-svg-icons';
// import { faSpinner } from '@fortawesome/pro-light-svg-icons'
import { faTwitter } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faBold, faItalic, faUnderline, faStrikethrough,
  faH1, faH2, faH3, faH4,
  faListOl, faListUl, faHorizontalRule,
  faPlusCircle, faMinusCircle,
  faFilePlus, faPrint,
  faBars, faTrashAlt, faTimes,
  faTwitter
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
